import styled, { Modal } from "grabcad-ui-elements";

export const ModalContainer = styled.div`
    max-width: 600px !important;
    padding: 23px 31px;
    background: white;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    gap: 24px;
`;

export const AnalyzeBannerModal = styled(Modal)`
    max-width: 600px !important;
`;

export const StyledText = styled.span`
    font-size: 16px;
    line-height: 125%;
`;

export const IconsContainer = styled.div`
    position: relative;
    width: 100%;
`;

export const InfoIconWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 16px;
    width: 100%;

    svg {
        display: block;
    }
`;

export const CancelIconWrapper = styled.div`
    position: absolute;
    top: 16px;
    right: 8px;
    display: flex;
    justify-content: flex-end;
    align-items: flex-start;
`;
